import React from 'react'

// Prevent single words from being on their own line
export default function preventWidowedWords(string) {
  if (string) {
    var wordArray = string.split(" ");
    if (wordArray.length > 1) {
      wordArray[wordArray.length - 2] += "&nbsp;" + wordArray[wordArray.length - 1]
      wordArray.pop()
      return <span dangerouslySetInnerHTML={{ __html: wordArray.join(" ") }} />
    } 
  } else {
    return ''
  }
}
